import { Editor } from '@tiptap/core';
import { DOMSerializer, Fragment } from '@tiptap/pm/model';
import inferSelectionKind from './inferSelectionKind.helper';
import expandBlockSelection from './expandBlockSelection.helper';
import { TBlockItemType } from '../types';

export type TSelectionSnapshot = {
  kind: TBlockItemType;
  html: string;
  text: string;
};

const captureSelectionSnapshot = (editor: Editor): TSelectionSnapshot | null => {
  const kind = inferSelectionKind(editor);
  if (!kind) return null;

  const { selection, doc, schema } = editor.state;
  const { from, to } = expandBlockSelection(selection);
  const { content } = doc.slice(from, to);
  const $from = doc.resolve(from);
  const parent = $from.node($from.sharedDepth(to));
  // A slice inside one textblock holds only its inline content, which would lose the paragraph and its style.
  const fragment = parent.isTextblock ? Fragment.from(parent.copy(content)) : content;
  const container = document.createElement('div');
  container.appendChild(DOMSerializer.fromSchema(schema).serializeFragment(fragment));

  return { kind, html: container.innerHTML, text: doc.textBetween(selection.from, selection.to) };
};

export default captureSelectionSnapshot;
